// extracted by mini-css-extract-plugin
export default {"textBtn":"textBtn___c512Q","sizeDefault":"sizeDefault___tnq3Z","sizeCompact":"sizeCompact___kNFXt","primary":"primary___etB8Q","default":"default___zAVPP","danger":"danger___QGQJz"};